import { gql } from '@apollo/client'
import { BodyText, Heading } from '@farol-ds/react'

import { CheckoutButton } from '../checkout-button'
import { OneClickButton } from '../one-click-button'
import {
  OneMonitorCreditsBuyContent_OfferLockDataFragment,
  OneMonitorCreditsBuyContent_ViewerFragment,
} from './__generated__/one-monitor-credits-buy-content.graphql'
import styles from './one-monitor-credits-buy-content.module.scss'

type OneMonitorCreditsBuyContentProps = {
  offerLockData: OneMonitorCreditsBuyContent_OfferLockDataFragment
  viewer: OneMonitorCreditsBuyContent_ViewerFragment
}

export function OneMonitorCreditsBuyContent({
  offerLockData,
  viewer,
}: OneMonitorCreditsBuyContentProps) {
  const { header, body } = offerLockData
  const { title, subtitle } = header
  const {
    cards: [card],
  } = body || {}

  const [description] = card.descriptions

  return (
    <>
      <div className={styles.header}>
        <Heading size="lg" className={styles.title}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Heading>
        <BodyText size="md" className={styles.subtitle}>
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </BodyText>
        <BodyText size="md" className={styles.description}>
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </BodyText>
      </div>

      <div className={styles.card}>
        <CheckoutButton offerLockCard={card} kind="primary" viewer={viewer} />
        <OneClickButton offerLockCard={card} viewer={viewer} kind="primary" />
      </div>
    </>
  )
}

OneMonitorCreditsBuyContent.fragments = {
  offerLockData: gql`
    fragment OneMonitorCreditsBuyContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        cards {
          descriptions
          button {
            label
          }
          offer {
            priceText
            frequency
          }
          ...CheckoutButton_offerLockCard
          ...OneClickButton_offerLockCard
        }
      }
    }
    ${CheckoutButton.fragments.offerLockCard}
    ${OneClickButton.fragments.offerLockCard}
  `,
  viewer: gql`
    fragment OneMonitorCreditsBuyContent_viewer on Profile {
      ...OneClickButton_viewer
      ...CheckoutButton_viewer
    }
    ${OneClickButton.fragments.viewer}
    ${CheckoutButton.fragments.viewer}
  `,
}
